import React from 'react';

// Texto jurídico fornecido pelo cliente — mantido tal como recebido, com
// uma correção: "duronostrum.pt" (sem o "o") corrigido para
// "douronostrum.pt" — gralha óbvia no domínio, não uma escolha de
// conteúdo.
export default function PoliticaCookies() {
  return (
    <div className="page-top">
      <section className="section--sm">
        <div className="container container--narrow">
          <p className="t-label" style={{ color: 'rgba(0,0,0,0.6)', marginBottom: 'var(--sp-4)' }}>
            <span className="overline" />
            Legal
          </p>
          <h1 className="t-h1" style={{ marginBottom: 'var(--sp-10)' }}>
            Política de Cookies
          </h1>

          <div className="legal-content">
            <p className="t-body">
              A presente Política de Cookies (daqui em diante, a “Política de Cookies” ou “Política”) permitir-lhe-á obter mais informação sobre a utilização dos nossos serviços ao aceder aos websites da Quinta de Braceiras - Sociedade Agrícola Lda, e pode ser complementada por disposições locais.
            </p>
            <p className="t-body">
              Esta não é aplicável a websites de terceiros que possam ser acedidas através de um link disponibilizado nos websites da Quinta de Braceiras - Sociedade Agrícola Lda.
            </p>
            <p className="t-body">
              Os websites da Quinta de Braceiras - Sociedade Agrícola Lda utilizam cookies e/ou tecnologias semelhantes que recolhem e armazenam informação à medida que o utilizador navega nos mesmos.
            </p>

            <h2 className="t-h3">1. O que são cookies?</h2>
            <p className="t-body">
              Os cookies são pequenos fragmentos de texto que as páginas dos websites que visita enviam para o navegador que está a utilizar e que permitem a recolha e armazenamento de informação. Estes são utilizados para diferentes finalidades como por exemplo, identificá-lo(a) enquanto utilizador, obter informação sobre os seus hábitos de navegação ou personalizar os conteúdos que lhe são apresentados. Podem ser classificados de acordo com a sua origem, propósito e duração.
            </p>

            <h2 className="t-h3">2. A quem pertencem os cookies?</h2>
            <p className="t-body">Quanto à sua origem podemos classificar os cookies como:</p>
            <ul className="t-body">
              <li>Cookies próprios (first-party): cookies geridos e armazenados pela Quinta de Braceiras - Sociedade Agrícola Lda</li>
              <li>
                Cookies de terceiros (third-party): cookies geridos e armazenadas por entidades que têm conteúdos ou sistemas integrados nas páginas dos websites da Quinta de Braceiras - Sociedade Agrícola Lda utiliza, por exemplo, os seguintes cookies de terceiros:
                <ul>
                  <li>Google</li>
                </ul>
              </li>
            </ul>

            <h2 className="t-h3">3. Para que finalidades são utilizados os cookies?</h2>
            <p className="t-body">Quanto ao seu propósito podemos classificar os cookies como:</p>
            <ul className="t-body">
              <li>
                Cookies necessários: são cookies de caráter técnico que permitem ao utilizador navegar no website, ativando funções básicas como a navegação nas páginas e o acesso a áreas seguras das mesmas e permitem a gestão e operação do website. Para estes cookies não é recolhido o consentimento pois a página web ou os serviços não podem funcionar adequadamente sem os mesmos.
              </li>
              <li>
                Cookies preferenciais: são cookies que permitem memorizar informação sobre as suas navegações anteriores para que aceda ao serviço com determinadas caraterísticas que podem personalizar a sua experiência. Estes cookies permitem, por exemplo, reconhecer o idioma do utilizador, impedir ou dificultar ataques contra a página web ou os seus utilizadores, garantir a correta reprodução de conteúdos multimédia e melhorar a distribuição do tráfego web.
              </li>
              <li>
                Cookies estatísticos (analíticos): são cookies que permitem efetuar um acompanhamento e análises do comportamento dos utilizadores nos websites da Quinta de Braceiras - Sociedade Agrícola Lda. Qualquer informação recolhida através deste tipo de cookies é utilizada para medir a atividade em qualquer website, com a finalidade de introduzir melhorias em função da análise dos dados relativos à utilização do serviço por parte dos utilizadores. Graças a isso podemos melhorar as nossas páginas, bem como a oferta de produtos ou serviços que realizamos.
              </li>
              <li>
                Cookies de marketing: são cookies que nos permitem conhecer os seus hábitos de navegação e mostrar-lhe publicidade relacionada com o seu perfil de navegação, gerindo eficazmente os espaços publicitários. Têm como finalidade exibir anúncios relevantes, adequando o seu conteúdo ao utilizador.
              </li>
              <li>Cookies Não classificados: são os cookies que ainda se encontram em processo de classificação.</li>
            </ul>

            <h2 className="t-h3">4. Durante quanto tempo podem ser armazenados?</h2>
            <p className="t-body">Quanto à duração, os cookies podem ser classificados como:</p>
            <ul className="t-body">
              <li>Cookies de sessão: até ao fecho do navegador ou término da sessão;</li>
              <li>
                Cookies persistentes: armazenados durante períodos mais extensos, sendo por isso necessária ação por parte do utilizador por forma a eliminar estes cookies. A Quinta de Braceiras - Sociedade Agrícola Lda não armazena cookies com uma duração superior a 2 anos.
              </li>
            </ul>

            <h2 className="t-h3">5. Como é recolhido o seu consentimento?</h2>
            <p className="t-body">Este consentimento é solicitado no momento de visita aos websites.</p>

            <h2 className="t-h3">6. Como posso revogar, configurar ou rejeitar a recolha e utilização de cookies?</h2>
            <p className="t-body">
              Em qualquer momento poderá também configurar os cookies através do seu navegador (browser) para que possa permitir, bloquear ou eliminar os cookies instalados. Neste caso, deve ter em conta que, embora tenha apenas os cookies necessários para usar ou navegar nos websites Quinta de Braceiras - Sociedade Agrícola Lda, se desativar os restantes cookies não poderá aceder a todas as funcionalidades que lhe disponibilizamos. O botão de “Ajuda” do seu explorador disponibiliza-lhe informação adicional sobre como configurar o seu navegador.
            </p>
            <p className="t-body">
              Em seguida, explicamos-lhe como, mas tenha em conta que o procedimento poderá variar em função do navegador que estiver a utilizar:
            </p>
            <ul className="t-body">
              <li>Google Chrome;</li>
              <li>Mozilla Firefox;</li>
              <li>Internet Explorer;</li>
              <li>Safari;</li>
              <li>Safari para IOS (iPhone e iPad); e</li>
              <li>Chrome para Android.</li>
            </ul>
            <p className="t-body">
              Se rejeitar a instalação de cookies, poderá continuar a utilizar os websites Quinta de Braceiras - Sociedade Agrícola Lda, mas a utilização de alguns dos seus serviços poderá ficar limitada e a usabilidade da navegação poderá ficar diminuída (e.g. no que diz respeito aos cookies preferenciais).
            </p>
            <p className="t-body">Todas as suas preferências serão armazenadas até que decida efetuar novas alterações.</p>

            <h2 className="t-h3">7. Que tipo de cookies utiliza a Quinta de Braceiras - Sociedade Agrícola Lda?</h2>
            <p className="t-body">
              Para mais informações sobre os cookies que a Quinta de Braceiras - Sociedade Agrícola Lda recolhe, nomeadamente as suas finalidades, origem e período de conservação.
            </p>
            <p className="t-body">
              Este website utiliza cookies. Utilizamos cookies próprios para melhoria da sua experiência como utilizador.
            </p>
            <p className="t-body">
              Os cookies são pequenos fragmentos de texto que as páginas dos websites que visita enviam para o navegador que está a utilizar e que permitem a recolha e armazenamento de informação. Para mais informações por favor consulte a nossa Política. Para saber mais como a Quinta de Braceiras - Sociedade Agrícola Lda trata os seus dados por favor consulte a Politica de Privacidade.
            </p>
            <p className="t-body">O seu consentimento aplica-se aos seguintes domínios: douronostrum.pt</p>
            <p className="t-body">
              Cookies de caráter técnico que permitem ao utilizador navegar no website, ativando funções básicas como a navegação nas páginas e o acesso a áreas seguras das mesmas e permitem a gestão e operação do website. O website não funciona corretamente sem estes cookies.
            </p>

            <h2 className="t-h3">8. São realizadas transferências internacionais?</h2>
            <p className="t-body">
              Em caso de transferência internacional de dados, a Quinta de Braceiras - Sociedade Agrícola Lda compromete-se a proceder a tal transferência em total respeito pelas disposições legais aplicáveis.
            </p>

            <h2 className="t-h3">9. Atualizações e alterações à Política de Cookies?</h2>
            <p className="t-body">
              A Quinta de Braceiras - Sociedade Agrícola Lda pode modificar a presente Política de Cookies com base em novos requisitos legais, para implementar melhorias na mesma notificando, no caso de mudanças significativas, por meio de um aviso informativo nas nossas páginas web.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
